import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listTimeSlots: [],
    lastFetch: null,
    consultationType: [],
    cashAccepted: false,
    emergency: false,
    currentDay: null,
    // Added so components can react to fetch state instead of silent console.error
    loading: false,
    error: null,
}

const timeslotsSlice = createSlice({
    name: 'timeslots',
    initialState,
    reducers: {
        setTimeSlots: (state, action) => {
            state.listTimeSlots = [...action.payload];
            state.lastFetch = Date.now();
            state.loading = false;
            state.error = null;
        },
        refreshTimeSlots: (state, action) => {
            state.listTimeSlots = [...action.payload];
        },
        setTimeSlotsLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        setTimeSlotsError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        updateConsultationType: (state, action) => {
            state.consultationType = [...action.payload.consultationType];
            state.cashAccepted = action.payload.cashAccepted;
            state.emergency = action.payload.emergency;
        },
        changeCurrentDay: (state, action) => {
            state.currentDay = action.payload; // Update the currentDay state
        },
        resetTimeSlots: state => {
            state.listTimeSlots = [];
            state.lastFetch = null;
            state.loading = false;
            state.error = null;
        }
    }
})

export const { setTimeSlots, refreshTimeSlots, updateConsultationType, changeCurrentDay, resetTimeSlots, setTimeSlotsLoading, setTimeSlotsError } = timeslotsSlice.actions;
export default timeslotsSlice.reducer;